import { render, staticRenderFns } from "./OrganizationInput.vue?vue&type=template&id=5d52cf7a&"
import script from "./OrganizationInput.vue?vue&type=script&lang=js&"
export * from "./OrganizationInput.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationInput.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/OrganizationInput.vue
// module id = 1144
// module chunks = 0